/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import DashboardShell from "../../dashboard/DashboardShell";
import { useDashboardLevelContext } from "../../../context/levels";
import { getSingleLevelDashboard } from "../../../lib/sysNavigation/SysNavigation";

const LEVEL_FIELD = {
  First: "first_level_id",
  Second: "second_level_id",
  Third: "third_level_id",
  Fourth: "fourth_level_id",
};

const DashboardLevel = () => {
  const { data, level } = getSingleLevelDashboard();
  const lvl = level || "First";
  const { statsLevel, fetchLevelData } = useDashboardLevelContext();

  const level_id = data?.[LEVEL_FIELD[lvl]] ?? null;
  const levelName = data?.name ?? "Level";

  useEffect(() => {
    if (level_id) fetchLevelData(level_id, lvl);
  }, [level_id, lvl]);

  return (
    <DashboardShell
      title={levelName}
      subtitle={`${lvl} level · content footprint`}
      stats={statsLevel}
      clickRoute="/levels/first"
      showTableStats={false}
      hideGeography
      breadCrumbDefault={false}
    />
  );
};

export default DashboardLevel;
